const keyNames = {
  REUSABLE: "REUSABLE",
  token: "token",
  tataToken: "tataToken",
  apiErrors: "apiErrors",
  themeMode: "themeMode",
  apiMsg: "apiMsg",
  extra: "extra",
  isLoading: "isLoading",
  toastData: "toastData",
  isAuthenticated: "isAuthenticated",
  //End multiple
  forceLogOut: "forceLogOut",
  userData: "userData",
  allEmployeesData: "allEmployeesData",
  registeredUserData: "registeredUserData",
  createdCampaignData: "createdCampaignData",
  campaignData: "campaignData",
  campaignDetails: "campaignDetails",
  campaignsOfProgramManagerData: "campaignsOfProgramManagerData",
  programManagersData: "programManagersData",
  allAgentsData: "allAgentsData",
  allocAndUnallocAgentData: "allocAndUnallocAgentData",
  allAssignedAgentsData: "allAssignedAgentsData",
  allCampignByAgentIdData: "allCampignByAgentIdData",
  allNonAssignedAgentsData: "allNonAssignedAgentsData",
  agentsProgramData: "agentsProgramData",
  campaignDatabaseData: "campaignDatabaseData",
  assignDatabaseToAgent: "assignDatabaseToAgent",
  allCampignDatabaseByAgentId: "allCampignDatabaseByAgentId",
  callingDataByAgentId: "callingDataByAgentId",
  addCallHistory: "addCallHistory",
  addCallRecording: "addCallRecording",
  callHistories: "callHistories",
  updateCallHistory: "updateCallHistory",
  callingDataById: "callingDataById",
  allinvoiceData: "allinvoiceData",
  invoiceAgents: "invoiceAgents",
  invoiceAgentData: "invoiceAgentData",
  invoicesByPMAndMonth: "invoicesByPMAndMonth",
  invoicesOfAgent: "invoicesOfAgent",
  allGenInvoicesOfPmMonthWise: "allGenInvoicesOfPmMonthWise",
  dashboardData: "dashboardData",
  allAgentsReportData: "allAgentsReportData",
  hourlyAnalysisData: "hourlyAnalysisData",
  attendanceData: "attendanceData",
  uploadexcelDatabase: "uploadexcelDatabase",

  //master database users data
  allUsersMasterdbData: "allUsersMasterdbData",
  allMasterDataWithEngagements: "allMasterDataWithEngagements",
  updateUserMasterdb: "updateUserMasterdb",
  allCompaniesDataMasterdb: "allCompaniesDataMasterdb",
  getAllCompanyName: "getAllCompanyName",
  addMasterDataBatch: "addMasterDataBatch",
  dropdownFiltersData: "dropdownFiltersData",
  dynamicDropdownOptions: "dynamicDropdownOptions",
  addfilteredDatabaseStats: "addfilteredDatabaseStats",
  clientfilteredDatabaseStatsData: "clientfilteredDatabaseStatsData",
  allcompaniesMatchedData: "allcompaniesMatchedData",
  matchDataCampaignId: "matchDataCampaignId",
  matchJobResponse: "matchJobResponse",
  clientMatchAction: "clientMatchAction",
  filteredDatabaseStatsData: "filteredDatabaseStatsData",
  assignCallingData: "assignCallingData",
  approvalData: "approvalData",
  approvalAction: "approvalAction",
  CompanyDataById: "CompanyDataById",
  mergeCompaniesResult: "mergeCompaniesResult",
  individualSearchResult: "individualSearchResult",
  assignIndividualSearchResult: "assignIndividualSearchResult",

  //wehooks data
  allEmailData: "allEmailData",
  allTemplateData: "allTemplateData",
  //linkwedin
  uploadedLinkedinProfiles: "uploadedLinkedinProfiles",
  allLinkedinProfilesData: "allLinkedinProfilesData",
  downloadLinkedinProfilesData: "downloadLinkedinProfilesData",
  //templates
  allTemplatesData: "allTemplatesData",
  sendEmailWithTemplate: "sendEmailWithTemplate",
  allEmailStatusData: "allEmailStatusData",

  //whatapp
  allWhatsappTemplatesData: "allWhatsappTemplatesData",
  sendWhatsappMessageData: "sendWhatsappMessageData",

  //external registrations
  uploadExternalRegistration: "uploadExternalRegistration",
  getAllExternalRegistrations: "getAllExternalRegistrations",

  //magicLinks
  generateMagicLink: "generateMagicLink",
  filterResultsSummary: "filterResultsSummary",

  // reconfirmation campaigns
  createReconfirmationCampaign: "createReconfirmationCampaign",
  reconfirmationCampaigns: "reconfirmationCampaigns",

  // priority
  priorityList: "priorityList",
  setPriority: "setPriority",
  closePriority: "closePriority",

  engagementHistory: "engagementHistory",
};
export default keyNames;
